module.exports = "<div class=\"paper-header\" *ngIf=\"heading\">{{heading}}</div>\n<div class=\"paper-symbol\" *ngIf=\"symbol\">\n    <iicon *ngIf=\"!expand\" icon=\"resize-full\" class=\"shrink-expand\" (click)=\"expandChange.emit(true)\"></iicon>\n    <iicon *ngIf=\"expand\" icon=\"resize-small\" class=\"shrink-expand\" (click)=\"expandChange.emit(false)\"></iicon>\n</div>\n\n<div class=\"paper-content\">\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-card/paper-card.component.html
// module id = ./src/app/components/polymer/paper-card/paper-card.component.html
// module chunks = main